var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('containerUpdate',{attrs:{"btnTitle":"Обновить Offices","keyName":_vm.keyName,"title":"Offices 22.1.064","svg":"office"},on:{"finish":function($event){return _vm.$emit('finish', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }